import React, { createContext, useEffect, useState } from "react";
import { ReportNumber } from "../../constants/ReportNumber";
import { useRole } from "../Authentication/RolePermission";
import { Roles } from "../../constants/Roles";
import { startOfToday, subDays } from "date-fns";
import dayjs from "dayjs";
import { ReportModuleRidrection } from "../../constants/ReportModuleRedirection";
import { parseISO } from "date-fns";

const ReportModuleContext = createContext();

const ReportModuleProvider = ({ children }) => {
  const role = useRole();
  const [reportCampaignId, setReportCampaignId] = useState(0);
  const [placementAnalysisCampaignId, setPlacementAnalysisCampaignId] =
    useState(0);
  const [placementAnalysisBrandId, setPlacementAnalysisBrandId] = useState(0);

  const [placementAnalysisRedirect, setPlacementAnalysisRedirect] = useState(false);

  useEffect(()=>{
    console.log("placementAnalysisRedirect-->",placementAnalysisRedirect);
    
  },[placementAnalysisRedirect])
  
  const [accountRedirection, setAccountRedirection] = useState(false);
  const [brandRedirection, setBrandRedirection] = useState(false);
  const [partnerRedirection, setPartnerRedirection] = useState(false);
  const [creativeRedirection, setCreativeRedirection] = useState(false);
  const [strategyRedirection, setStrategyRedirection] = useState(false);
  const [siteRedirection, setSiteRedirection] = useState(false);
  const [
    campaignAnalysisRichMediaRedirection,
    setCampaignAnalysisRichMediaRedirection,
  ] = useState(false);

  const [campaignRichMediaRedirection, setCampaignRichMediaRedirection] =
    useState(false);
  const [reportStrategyId, setReportStrategyId] = useState(0);
  const [reportDeliveryChannelId, setReportDeliveryChannelId] = useState(0);
  const [reportAccountId, setReportAccountId] = useState(0);
  const [reportBrandId, setReportBrandId] = useState(0);
  const [reportCreativeId, setReportCreativeId] = useState(0);
  const [reportCreativeTypeId, setReportCreativeTypeId] = useState(0);
  const [reportPartnerId, setReportPartnerId] = useState(0);
  const [reportSiteId, setReportSiteId] = useState(0);
  const [reportRefresh, setReportRefresh] = useState(false);
  const [noData, setNoData] = useState(false);
  const [showContent, setShowContent] = useState(false);
  const [dashboardStartDate, setDashboardStartDate] = useState(
    dayjs(startOfToday()).format("YYYY-MM-DD")
  );
  const [dashboardEndDate, setDashboardEndDate] = useState(
    dayjs(new Date()).format("YYYY-MM-DD")
  );

  const [dashboardState, setDashboardState] = useState([
    {
      startDate: subDays(startOfToday(), 6),
      endDate: startOfToday(),
      key: "selection",
    },
  ]);

  useEffect(()=>{
    console.log("dashboardState-->",dashboardState);
    
  },[dashboardState])

useEffect(()=>{
  const urlParams = new URLSearchParams(window.location.search);
  const tabId = urlParams.get("tabId");
  const partnerId = urlParams.get("partnerId");
  const PlacementAnalysisRedirect = urlParams.get("PlacementAnalysisRedirect");
  const moduleRedirect = urlParams.get("moduleRedirect");
  const accountId = urlParams.get("accountId")
  const brandId = urlParams.get("brandId")
  const deliveryChannelId = urlParams.get("deliveryChannelId")
  const strategyId = urlParams.get("strategyId")
  const startDate = urlParams.get("startDate")
  const endDate = urlParams.get("endDate")
  const campaignId = urlParams.get("campaignId")
  const creativeId = urlParams.get("creativeId")
  const format = urlParams.get("format")
  const placement = urlParams.get("placement")
  const siteId = urlParams.get("siteId")
  const dashboardBtnType = urlParams.get("dashboardBtnType");
  const isDiyPartner = urlParams.get("isDiyPartner");

  console.log("Opened tab with tabId:", tabId);
  console.log("Opened tab with partnerId:", partnerId);
  console.log("PlacementAnalysisRedirect-->",PlacementAnalysisRedirect);
  console.log("moduleRedirect-->",moduleRedirect);
  
  setPlacementAnalysisRedirect(PlacementAnalysisRedirect === "true");
  setPlacementAnalysisCampaignId(campaignId);
  setPlacementAnalysisBrandId(brandId);
  setReportAccountId(accountId);
  setReportBrandId(brandId);
  setReportDeliveryChannelId(deliveryChannelId);
  setReportCreativeId(creativeId);
  setReportPartnerId(partnerId);
  setPartnerId(partnerId);
  setReportStrategyId(strategyId);
  setReportCreativeTypeId(format);
  setPlacementName(placement);
  setReportSiteId(siteId);
  setSiteId(siteId);
  setReportCampaignId(campaignId);
  handleModuleRedirect(moduleRedirect);
  if(placement && isDiyPartner !== "true"){
    setGoSteps(moduleRedirect == 6 ? ReportNumber.DETAILED_PLACEMENT : ReportNumber.WIDGET);
  }
  if(isDiyPartner === "true"){
    setGoSteps(ReportNumber.WIDGET);

  }
  // if (startDate && endDate) {
  //   setDashboardStartDate(startDate);
  //   setDashboardEndDate(endDate);
  //   setDashboardState([
  //     {
  //       startDate: parseISO(startDate), // Converts "YYYY-MM-DD" to Date object
  //       endDate: parseISO(endDate),
  //       key: "selection",
  //     },
  //   ]);
  // }
  
  setDashboardStartDate(startDate);
  setDashboardEndDate(endDate);
  setDashboardState([{
    startDate: parseISO(startDate), // Converts "YYYY-MM-DD" to Date object
    endDate: parseISO(endDate),
    key: "selection",
  }])
  setDashboardBtnType(dashboardBtnType);
},[])

  

  const [dashboardBtnType, setDashboardBtnType] = useState("last7Days");
  const [inScreenDelivery, setInScreenDelivery] = useState("9");



  // Widget Analysis Redirection
  const [partnerId, setPartnerId] = useState(0);
  const [placementName, setPlacementName] = useState("");
  const [siteId, setSiteId] = useState(0);
  const [goSteps, setGoSteps] = useState(
    role == Roles.CREATIVE
      ? ReportNumber.WIDGET
      : role == Roles.DIY_PARTNER || role == Roles.PARTNER || role == Roles.SITE
      ? ReportNumber.WIDGET
      : ReportNumber.DETAILED_PLACEMENT
  );
  


  const handleModuleRedirect = (ModuleNumber) => {
    const defaultState = {
      accountRedirection: false,
      brandRedirection: false,
      partnerRedirection: false,
      creativeRedirection: false,
      strategyRedirection: false,
      siteRedirection: false,
      campaignAnalysisRichMediaRedirection: false,
      campaignRichMediaRedirection:false,
    };
  

    const moduleStateMap = {
      [ReportModuleRidrection.NOT_REDIRECTED]: {...defaultState},
      [ReportModuleRidrection.ACCOUNT]: { accountRedirection: true },
      [ReportModuleRidrection.BRAND]: { brandRedirection: true },
      [ReportModuleRidrection.CREATIVE]: { creativeRedirection: true },
      [ReportModuleRidrection.PARTNER]: { partnerRedirection: true },
      [ReportModuleRidrection.STRATEGY]: { strategyRedirection: true },
      [ReportModuleRidrection.SITE]: { siteRedirection: true },
      [ReportModuleRidrection.CAMPAIGN_ANALYSIS_RICH_MEDIA]: { campaignAnalysisRichMediaRedirection: true },
      [ReportModuleRidrection.CAMPAIGN_RICH_MEDIA]: { campaignRichMediaRedirection: true },
    };
  
    // Apply the default state
    // setPlacementAnalysisRedirect(false);
    // setPlacementAnalysisCampaignId(0);
    setGoSteps(ReportNumber.WIDGET);
  
    // Merge the module-specific changes
    const updatedState = { ...defaultState, ...moduleStateMap[ModuleNumber] };
  
    // Update the states
    setAccountRedirection(updatedState.accountRedirection);
    setBrandRedirection(updatedState.brandRedirection);
    setPartnerRedirection(updatedState.partnerRedirection);
    setCreativeRedirection(updatedState.creativeRedirection);
    setStrategyRedirection(updatedState.strategyRedirection);
    setSiteRedirection(updatedState.siteRedirection);
    setCampaignAnalysisRichMediaRedirection(updatedState.campaignAnalysisRichMediaRedirection)
    setCampaignRichMediaRedirection(updatedState.campaignRichMediaRedirection)
    
    
  };

  const reportStateRefresh = () => {
    setReportCampaignId(0);
    setReportAccountId(0);
    setReportBrandId(0);
    setReportCreativeId(0);
    setReportPartnerId(0);
    setReportStrategyId(0);
    setPlacementAnalysisCampaignId(0);
    setPlacementAnalysisRedirect(false);
    setAccountRedirection(false);
    setBrandRedirection(false);
    setPartnerRedirection(false);
    setCreativeRedirection(false);
    setSiteRedirection(false);
    setReportDeliveryChannelId(0);
    setReportCreativeTypeId(0);
  };

  return (
    <ReportModuleContext.Provider
      value={{
        reportCampaignId,
        setReportCampaignId,
        reportAccountId,
        setReportAccountId,
        reportBrandId,
        setReportBrandId,
        reportCreativeId,
        setReportCreativeId,
        reportPartnerId,
        setReportPartnerId,
        reportSiteId,
        setReportSiteId,
        reportStrategyId,
        setReportStrategyId,
        reportRefresh,
        setReportRefresh,
        noData,
        setNoData,
        placementAnalysisCampaignId,
        setPlacementAnalysisCampaignId,
        placementAnalysisBrandId,
        setPlacementAnalysisBrandId,
        placementAnalysisRedirect,
        setPlacementAnalysisRedirect,
        strategyRedirection,
        setStrategyRedirection,
        siteRedirection,
        setSiteRedirection,
        showContent,
        setShowContent,
        partnerId,
        setPartnerId,
        placementName,
        setPlacementName,
        siteId,
        setSiteId,
        goSteps,
        setGoSteps,
        accountRedirection,
        setAccountRedirection,
        brandRedirection,
        setBrandRedirection,
        partnerRedirection,
        setPartnerRedirection,
        creativeRedirection,
        setCreativeRedirection,
        reportDeliveryChannelId,
        setReportDeliveryChannelId,
        reportCreativeTypeId,
        setReportCreativeTypeId,
        handleModuleRedirect,
        reportStateRefresh,
        dashboardStartDate,
        setDashboardStartDate,
        dashboardEndDate,
        setDashboardEndDate,
        dashboardState,
        setDashboardState,
        dashboardBtnType,
        setDashboardBtnType,
        inScreenDelivery,
        setInScreenDelivery,
        campaignAnalysisRichMediaRedirection,
        setCampaignAnalysisRichMediaRedirection,
        campaignRichMediaRedirection,
        setCampaignRichMediaRedirection,
      }}
    >
      {children}
    </ReportModuleContext.Provider>
  );
};

export { ReportModuleProvider, ReportModuleContext };
